import { apiClient } from './apiClient';
import { API_BASE_URL } from '../constants/api';
import type {
  KSeFConfiguration,
  KSeFTestResponse,
  KSeFCertificateResponse
} from '../types/businessProfile';

export const ksefService = {
  async configureKSeF(
    businessProfileId: string,
    config: KSeFConfiguration,
    authToken: string
  ): Promise<void> {
    await apiClient.post(
      `/business-profile/${businessProfileId}/ksef/configure`,
      config,
      authToken
    );
  },

  async configureKSeFCertificate(
    businessProfileId: string,
    certificate: File,
    password: string,
    environment: 'Test' | 'Production',
    authToken: string,
    privateKey?: File
  ): Promise<KSeFCertificateResponse> {
    const formData = new FormData();
    formData.append('certificate', certificate);
    formData.append('password', password);
    formData.append('environment', environment);

    // Add private key file if provided (for CRT/CER/PEM formats)
    if (privateKey) {
      formData.append('privateKey', privateKey);
    }

    const response = await fetch(
      `${API_BASE_URL}/business-profile/${businessProfileId}/ksef/configure-certificate`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${authToken}`,
        },
        body: formData,
      }
    );

    if (!response.ok) {
      const error = await response.json().catch(() => ({ message: 'Failed to configure certificate' }));
      throw new Error(error.message || 'Failed to configure certificate');
    }

    return response.json();
  },

  async testKSeFConnection(
    businessProfileId: string,
    authToken: string
  ): Promise<KSeFTestResponse> {
    return apiClient.post<KSeFTestResponse>(
      `/business-profile/${businessProfileId}/ksef/test`,
      {},
      authToken
    );
  },

  async enableKSeF(
    businessProfileId: string,
    enabled: boolean,
    authToken: string
  ): Promise<void> {
    await apiClient.put(
      `/business-profile/${businessProfileId}/ksef/enable`,
      { enabled },
      authToken
    );
  },
};
